(function () {
  'use strict';

  var galleryId = '24428';
  var selector = '.reelfy-gallery[data-id="' + galleryId + '"]';
  var gallery = document.querySelector(selector);

  if (!gallery || gallery.dataset.mfFallbackReady === 'true') return;
  gallery.dataset.mfFallbackReady = 'true';

  var wrapper = gallery.closest('.reelfy-wrapper');
  var section = gallery.closest('.shopify-section') || wrapper || gallery;
  var sectionSurface = gallery.closest('.side-margins');
  var main = gallery.querySelector('.rf-gallery-main');
  var loading = false;

  if (!main) return;

  function nativeGalleryIsReady() {
    return Boolean(gallery.querySelector('.rf-video-item'));
  }

  function addStyles() {
    if (document.getElementById('mf-reelfy-fallback-styles')) return;

    var style = document.createElement('style');
    style.id = 'mf-reelfy-fallback-styles';
    style.textContent =
      '.mf-reelfy-fallback{display:block!important;width:100%;}' +
      '.mf-reelfy-fallback .rf-gallery-main{display:block!important;min-height:0;}' +
      '.mf-reelfy-surface{background:#000!important;color:#fff;}' +
      '.mf-reelfy-grid{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(210px,1fr);gap:16px;overflow-x:auto;overscroll-behavior-inline:contain;scroll-snap-type:x proximity;padding:4px 2px 14px;scrollbar-width:thin;}' +
      '.mf-reelfy-card{position:relative;display:block;width:100%;aspect-ratio:9/16;padding:0;border:0;border-radius:0;overflow:hidden;background:#151515;cursor:pointer;scroll-snap-align:start;color:#fff;}' +
      '.mf-reelfy-card img,.mf-reelfy-card video{display:block;width:100%;height:100%;object-fit:cover;}' +
      '.mf-reelfy-play{position:absolute;left:50%;top:50%;display:grid;place-items:center;width:50px;height:50px;border-radius:50%;background:rgba(0,0,0,.58);transform:translate(-50%,-50%);font-size:22px;line-height:1;padding-left:3px;}' +
      '.mf-reelfy-play[hidden]{display:none;}' +
      '.mf-reelfy-duration{position:absolute;right:8px;bottom:8px;padding:3px 7px;border-radius:3px;background:rgba(0,0,0,.72);font:600 12px/1.2 sans-serif;}' +
      '@media (min-width:990px){.mf-reelfy-grid{grid-auto-columns:calc((100% - 48px)/4);}}' +
      '@media (max-width:749px){.mf-reelfy-surface{padding-top:12px!important;padding-bottom:12px!important;}.mf-reelfy-grid{grid-auto-columns:calc((100% - 12px)/2);gap:12px;padding-bottom:8px;scrollbar-width:none;}.mf-reelfy-grid::-webkit-scrollbar{display:none;}.mf-reelfy-play{width:44px;height:44px;}}';
    document.head.appendChild(style);
  }

  function render(videos) {
    if (nativeGalleryIsReady() || !videos.length) return;

    addStyles();
    gallery.classList.remove('rfHidden');
    gallery.classList.add('mf-reelfy-fallback');
    if (wrapper) {
      wrapper.classList.remove('rfHidden');
      wrapper.classList.add('mf-reelfy-fallback');
    }
    if (sectionSurface) sectionSurface.classList.add('mf-reelfy-surface');

    var grid = document.createElement('div');
    grid.className = 'mf-reelfy-grid';
    grid.setAttribute('aria-label', 'Influencer videos');

    videos.forEach(function (videoData) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'mf-reelfy-card';
      card.setAttribute('aria-label', 'Play ' + (videoData.title || 'influencer video'));

      var image = document.createElement('img');
      image.src = videoData.thumbnail;
      image.alt = videoData.title ? videoData.title.replace(/\.[^.]+$/, '') : 'Mantra Flow influencer video';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 300;
      image.height = Math.round(300 * ((videoData.height || 16) / (videoData.width || 9)));

      var play = document.createElement('span');
      play.className = 'mf-reelfy-play';
      play.setAttribute('aria-hidden', 'true');
      play.textContent = '\u25b6';

      card.appendChild(image);
      card.appendChild(play);

      if (videoData.duration) {
        var duration = document.createElement('span');
        duration.className = 'mf-reelfy-duration';
        duration.textContent = videoData.duration;
        card.appendChild(duration);
      }

      card.addEventListener('click', function () {
        var inlineVideo = card.querySelector('video');

        gallery.querySelectorAll('.mf-reelfy-card video').forEach(function (otherVideo) {
          if (otherVideo !== inlineVideo) {
            otherVideo.pause();
            var otherPlay = otherVideo.parentElement.querySelector('.mf-reelfy-play');
            if (otherPlay) otherPlay.hidden = false;
          }
        });

        if (!inlineVideo) {
          inlineVideo = document.createElement('video');
          inlineVideo.playsInline = true;
          inlineVideo.setAttribute('playsinline', '');
          inlineVideo.setAttribute('webkit-playsinline', '');
          inlineVideo.preload = 'metadata';
          inlineVideo.poster = videoData.thumbnail || '';
          inlineVideo.src = videoData.section_video_url || videoData.popup_video_url || videoData.url;
          inlineVideo.addEventListener('ended', function () { play.hidden = false; });
          card.insertBefore(inlineVideo, card.firstChild);
          image.remove();
        }

        if (inlineVideo.paused) {
          inlineVideo.play().then(function () {
            play.hidden = true;
          }).catch(function () {
            play.hidden = false;
          });
        } else {
          inlineVideo.pause();
          play.hidden = false;
        }
      });
      grid.appendChild(card);
    });

    main.replaceChildren(grid);
  }

  function loadFallback() {
    if (loading || nativeGalleryIsReady()) return;
    loading = true;

    window.setTimeout(function () {
      if (nativeGalleryIsReady()) return;

      var endpoint = new URL('https://app.reelfy.app/gallery/' + galleryId);
      endpoint.searchParams.set('shop', window.Shopify && Shopify.shop ? Shopify.shop : 'itmk0u-1z.myshopify.com');
      endpoint.searchParams.set('page', 'index');
      endpoint.searchParams.set('handle', 'home');
      endpoint.searchParams.set('page_id', '');
      endpoint.searchParams.set('url', window.location.origin + '/');

      fetch(endpoint.toString(), { credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Gallery request failed');
          return response.json();
        })
        .then(function (data) {
          render(Array.isArray(data.videos) ? data.videos : []);
        })
        .catch(function () {
          loading = false;
        });
    }, 1200);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        observer.disconnect();
        loadFallback();
      }
    }, { rootMargin: '500px 0px' });
    observer.observe(section);
  } else {
    window.addEventListener('load', loadFallback, { once: true });
  }
})();
